import type { QueryClient } from '@tanstack/react-query';
import type { RouterHistory } from '@tanstack/react-router';
import { createAppQueryClient } from './queryClient';
import { createAppRouter } from './router';

export type AppRouter = ReturnType<typeof createAppRouter>;
export interface AppInstance { queryClient: QueryClient; router: AppRouter }

export function createApp(history?: RouterHistory): AppInstance {
  const queryClient = createAppQueryClient(onUnauthorized);
  const router = createAppRouter(queryClient, history);
  function onUnauthorized(): void {
    queryClient.clear();
    // Clearing makes still-mounted pages refetch, and those 401s land here again; one trip to sign in is enough.
    if (!/^\/sign-in\/?$/.test(router.latestLocation.pathname)) void router.navigate({ to: '/sign-in' });
  }
  return { queryClient, router };
}
